import { useEffect, useRef } from 'react';
import { cn } from '@jk-core/utils';
import { CalendarView } from '@/Calendar/type';
import styles from './YearTile.module.scss';

interface Props {
  selectedDate?: Date;
  onClick: (year: number) => void;
  tileContent?: (date: Date, view:CalendarView) => React.ReactNode;
  max: Date;
  min: Date;
}

export default function YearTile({
  selectedDate, onClick,
  tileContent = () => false,
  max, min,
}: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLButtonElement>(null);
  const YEARS = Array.from(
    { length: max.getFullYear() - min.getFullYear() + 1 },
    (_, i) => min.getFullYear() + i,
  );

  useEffect(() => {
    const selectedElement = selectedRef.current;
    const wrapperElement = wrapperRef.current;
    if (!selectedElement || !wrapperElement) return;

    const { clientHeight } = wrapperElement;
    const { offsetTop, clientHeight: selectedHeight } = selectedElement;

    wrapperElement.scrollTo({
      top: offsetTop - clientHeight / 2 + selectedHeight,
    });
  }, []);

  return (
    <div className={styles['year-tile']} ref={wrapperRef}>
      <div className={styles['year-tile__blank']} />
      {YEARS.map((year) => (
        <button
          className={cn({
            [styles['year-tile__year']]: true,
            [styles['year-tile__year--selected']]: !!selectedDate && selectedDate.getFullYear() === year,
            [styles['year-tile__year--border']]: !!tileContent(new Date(year, 0, 1), 'year'),
          })}
          key={year}
          type="button"
          ref={!!selectedDate && selectedDate.getFullYear() === year ? selectedRef : null}
          onClick={() => onClick(year)}
        >
          <span className={styles['yearTile__year--year']}>{year}</span>
          {tileContent(new Date(year, 0, 1), 'year') && (
            <div className={styles['yearTile__year--tile']}>
              {tileContent(new Date(year, 0, 1), 'year')}
            </div>
          )}
        </button>
      ))}
      <div className={styles['year-tile__blank']} />
    </div>
  );
}
